// @mui
import { alpha, styled } from '@mui/material/styles';
import {  ListItemIcon, ListSubheader, ListItemButton } from '@mui/material';
// config
import { ICON, NAV } from '../../../config';

// ----------------------------------------------------------------------

export const ListItemStyle =  styled(ListItemButton, {
    shouldForwardProp: (prop) => prop !== 'active' && prop !== 'caption',
})(({ active, disabled, depth, caption, theme }) => {
    const isLight = theme.palette.mode === 'light';

    const subItem = depth !== 1;

    const activeStyle = {
        color: theme.palette.primary.main,
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        ...(!isLight && {
            color: theme.palette.primary.light,
        }),
    };

    // Active child = the SAME colour (icon + label) and tinted pill as the active top-level
    // item (activeStyle), at the child row height — not near-black text.primary.
    const activeSubStyle = {
        ...activeStyle,
        borderLeft: `2px solid ${theme.palette.primary.main}`,
        paddingLeft: theme.spacing(1),
    };

    return {
        position: 'relative',
        textTransform: 'capitalize',
        paddingLeft: theme.spacing(1.25),
        paddingRight: theme.spacing(1),
        paddingTop: 0,
        paddingBottom: 0,
        // Tight density: 2px between rows; the active pill IS the row, so it can never be
        // taller than it. Radius 6px (was the theme's 8px).
        marginBottom: '2px',
        color: theme.palette.text.secondary,
        borderRadius: '6px',
        height: NAV.H_DASHBOARD_ITEM,
        minHeight: NAV.H_DASHBOARD_ITEM,
        // Sub item
        ...(subItem && {
            height: NAV.H_DASHBOARD_ITEM_SUB,
            minHeight: NAV.H_DASHBOARD_ITEM_SUB,
            ...(depth > 2 && {
                paddingLeft: theme.spacing(depth),
            }),
            ...(caption && {
                height: NAV.H_DASHBOARD_ITEM,
                minHeight: NAV.H_DASHBOARD_ITEM,
            }),
        }),
        // Active item
        ...(active && {
            ...activeStyle,
            '&:hover': {
                ...activeStyle,
            },
        }),
        // Active sub item
        ...(subItem &&
      active && {
            ...activeSubStyle,
            '&:hover': {
                ...activeSubStyle,
            },
        }),
        // Disabled
        ...(disabled && {
            '&.Mui-disabled': {
                opacity: 0.64,
            },
        }),
    };
});

// ----------------------------------------------------------------------

export const ListItemIconStyle  = styled(ListItemIcon)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: ICON.NAVBAR_ITEM,
    height: ICON.NAVBAR_ITEM,
    minWidth: 28,
    marginRight: 8,
    // Rendered glyph 18px (SvgColor is 20px, Iconify icons up to 24px) — one size for all.
    // The sub-item dot (ListDotIcon, [data-nav-dot]) keeps its own 6px size.
    '&& > *:not([data-nav-dot])': { width: 18, height: 18 },
});


// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled(ListSubheader)(({ theme }) => ({
    ...theme.typography.overline,
    fontSize: 11,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    color: theme.palette.text.secondary,
    backgroundColor: 'transparent',
}));

// ----------------------------------------------------------------------

export const ListDotIcon = styled('span', {
    shouldForwardProp: (prop) => prop !== 'active',
})(({ active, theme }) => ({
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: theme.palette.text.disabled,
    transition: theme.transitions.create(['transform', 'background-color'], {
        duration: theme.transitions.duration.shorter,
    }),
    ...(active && {
        transform: 'scale(1.5)',
        backgroundColor: theme.palette.primary.main,
    }),
}));

//
export const createButton = {
    width: '100%',
    py: 0.875,
    mb: '10px',
    borderRadius: '10px',
    fontWeight: 600,
    color: 'common.white',
    background: 'linear-gradient(135deg, #00B37E 0%, #005249 100%)',
    boxShadow: '0 2px 8px rgba(0, 179, 126, 0.4), inset 0 1px 0 rgba(255,255,255,0.15)',
    border: '1px solid rgba(0, 179, 126, 0.3)',
    transition: 'all 0.2s ease',
    '&:hover': {
        background: 'linear-gradient(135deg, #00C98A 0%, #006B5E 100%)',
        boxShadow: '0 4px 16px rgba(0, 179, 126, 0.5), inset 0 1px 0 rgba(255,255,255,0.2)',
        transform: 'translateY(-1px)',
    },
    '&:active': {
        transform: 'translateY(0)',
        boxShadow: '0 1px 4px rgba(0, 179, 126, 0.3)',
    },
    '.MuiButton-startIcon': {
        mr: '16px',
    },
    '.MuiButton-endIcon': {
        ml: '16px',
    },
};

export const badgeStyle = {
    borderRadius: '6px', 
    border: '1px solid #D93C36', 
    p: '1px 8px', 
    fontSize: '12px', 
    fontWeight: '700', 
    color: '#D93C36' 
};
